module.exports = __webpack_public_path__ + "img/liquor.caced377.svg";